import React from "react";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import { ServicesDrawer } from "../../../re-usable-components/ServicesDrawer.tsx";
import { faBell } from "@fortawesome/pro-regular-svg-icons";
import Box from "@vapor/react-material/Box";
import IconButton from "@vapor/react-material/IconButton";
import Filter from "@vapor/react-icons/Filter";
import TrashAlt from "@vapor/react-icons/TrashAlt";
import Gear from "@vapor/react-icons/Gear";
import { UnderlinedBox } from "../../../re-usable-components/UnderlinedBox.tsx";
import VaporIcon from "@vapor/react-icons/VaporIcon";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { faList } from "@fortawesome/free-solid-svg-icons";
import Toggle from "@vapor/react-material/Switch";
import { notificationDummyData } from "../../../../assets/DummyData.tsx";
import { NotificationCard } from "./NotificationCard.tsx";
import { Notification } from "../../types.ts";

export const Notifications: React.FC = () => {
  const unreadNotificationsCount = notificationDummyData.filter(
    (notification: Notification) => !notification.read
  ).length;

  return (
    <ServicesDrawer icon={faBell} drawerName="notificationDrawer">
      <UnderlinedBox>
        <ExtendedTypography variant="titleSmall" sx={{ m: 1, ml: 3 }}>
          Notifiche ({unreadNotificationsCount})
        </ExtendedTypography>
        <Box>
          <IconButton sx={{ mr: 1 }} color="primary">
            <Filter />
          </IconButton>
          <IconButton sx={{ mr: 1 }}>
            <VaporIcon color="primary" icon={faList} />
          </IconButton>
          <IconButton sx={{ mr: 1 }}>
            <TrashAlt color="primary" />
          </IconButton>
          <IconButton sx={{ mr: 1 }}>
            <VaporIcon color="primary" icon={faRotateRight} />
          </IconButton>
          <IconButton sx={{ mr: 1 }} color="primary">
            <Gear />
          </IconButton>
        </Box>
      </UnderlinedBox>
      <Box m={1}>
        <ExtendedTypography
          variant="bodySmall"
          color="primary.textDisabledColor"
          sx={{ ml: 2 }}
        >
          Monstra solo notifiche non lette
        </ExtendedTypography>
        <Toggle />
      </Box>
      {notificationDummyData.map((notification: Notification) => (
        <NotificationCard key={notification.id} notification={notification} />
      ))}
    </ServicesDrawer>
  );
};
